// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__1TUG9","noHoverBg":"CellularCapability_noHoverBg__2CLFa"};